module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_5010.f29e939d.png";